import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import TableView from '../../Components/TableView';

// const Wrapper = styled.div``;

const StatusTable = ({ data }) => {
  const columns = [
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (value) => value || '-',
      align: 'center',
    },
    {
      title: 'Number of Digests',
      dataIndex: 'count',
      key: 'count',
      render: (value) => value || '-',
      align: 'center',
    },
  ];
  return (
    <>
      <TableView tableColumns={columns} data={data} />
    </>
  );
};

StatusTable.propTypes = {
  data: PropTypes.object,
};

export default StatusTable;
